import type { PortraitFilterOption } from '../types/portrait-filter-option'

/**
 * The chosen option id to apply as a filter. A chosen id that is not in the loaded list (the group
 * was removed since, or the list failed to load) shows as unset in its field, so it must not keep
 * filtering and counting out of sight: it reads as '' until the list lists it again. While the list
 * is still loading the choice stands, since its name is about to appear.
 */
export function knownSelection(
  value: string,
  list: { options: PortraitFilterOption[]; isLoading: boolean }
): string {
  if (value === '' || list.isLoading) {
    return value
  }

  return list.options.some((option) => option.value === value) ? value : ''
}
